import React from 'react'
import styled from 'styled-components'

const CampaignHeaderContainer = styled.header`
  min-height: 48px;
  display: flex;
`
const Title = styled.h1`
  padding: 16px 48px 0;
  font-size: 12px;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  @media (min-width: 896px) {
    padding-bottom: 8px;
    font-size: 32px;
  }
`

interface CampaignHeader {
  title: string
}

const CampaignHeader: React.FC<CampaignHeader> = (props) => {
  return (
    <CampaignHeaderContainer>
      <Title>{props.title}</Title>
    </CampaignHeaderContainer>
  )
}

export default CampaignHeader
